export class ReportRequest {

	contentId: string;
	message: string;

}
